import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import GridOptions from './GridOptions';
import { icons } from '../../../../../shared/icons';

const GridProvider = ({
  data,
  handleOpenDialog,
  getEditData,
  isLoading,
  handleOpenDialogFile,
}) => {
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: 'Opcije',
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDialog(e.id)}
          getEditData={() => getEditData(e.row)}
          handleOpenDialogFile={() => handleOpenDialogFile(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    { field: 'naziv', headerName: 'Proizvođač', width: 200 },
    { field: 'sifra', headerName: 'Šifra mašine', width: 200 },
  ];

  return (
    <div style={{ height: '85vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

export default GridProvider;
